// Perfiles y modos del gestor (2026-10-06): lo que el cliente recuperado
// (vx en runtime) no tiene. Misma cabecera de llave que el resto del gestor.
import { rec_Qa as bajarArchivo, rec_api as api } from "../../runtime/index.jsx";

/** @param ocultos la llave del segundo PIN (chats ocultos), si está abierta */
export function clienteModos(llave, ocultos = null) {
  const headers = { "X-Gestor-Llave": llave, ...(ocultos ? { "X-Gestor-Ocultos": ocultos } : {}) };
  const qs = (o) => Object.entries(o).filter(([, v]) => v != null && v !== ``).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join(`&`);
  const escribir = (metodo, ruta, body, clave) =>
    api(ruta, { method: metodo, body, headers, clave: `${clave}-${Date.now()}` });
  return {
    modos: () => api(`/gestor/modos`, { sinCache: true, headers }),
    chats: () => api(`/gestor/chats`, { sinCache: true, headers }),
    ocultos: () => api(`/gestor/ocultos`, { sinCache: true, headers }),
    pinOcultos: (pin) => escribir(`POST`, `/gestor/ocultos/pin`, { pin }, `gestor-ocultos-pin`),
    abrirOcultos: (pin) => escribir(`POST`, `/gestor/ocultos/abrir`, { pin }, `gestor-ocultos-abrir`),
    cerrarOcultos: () => escribir(`POST`, `/gestor/ocultos/cerrar`, undefined, `gestor-ocultos-cerrar`),
    /** { q, tipo, chatId, desde, hasta } */
    buscar: (f) => api(`/gestor/buscar?${qs(f)}`, { sinCache: true, headers }),
    contadores: () => api(`/gestor/contadores`, { sinCache: true, headers }),
    eliminados: () => api(`/gestor/eliminados`, { sinCache: true, headers }),
    eliminadosVistos: () => escribir(`POST`, `/gestor/eliminados/vistos`, undefined, `gestor-eliminados-vistos`),
    unaVez: () => api(`/gestor/unavez`, { sinCache: true, headers }),
    /** nota: texto ("" = borrar, undefined = no tocar); abierto: true/false/undefined */
    anotar: (mensajeId, { nota, abierto }) => escribir(`POST`, `/gestor/mensajes/${mensajeId}/nota`, { nota, abierto }, `gestor-nota-${mensajeId}`),
    /** URL local de la foto de perfil (para <img>). */
    foto: (chatId) => bajarArchivo(`/gestor/chats/${chatId}/foto`, headers),
    crear: (modo) => escribir(`POST`, `/gestor/modos`, modo, `gestor-modo-nuevo`),
    guardar: (modo) => escribir(`PUT`, `/gestor/modos/${modo.id}`, modo, `gestor-modo-${modo.id}`),
    borrar: (id) => escribir(`DELETE`, `/gestor/modos/${id}`, undefined, `gestor-modo-borrar-${id}`),
    ordenar: (ids) => escribir(`PUT`, `/gestor/modos/orden`, ids, `gestor-modos-orden`),
    /** modoId null = «sin modo»; automatico = volver al horario; minutos null = hasta que se cambie. */
    activar: ({ modoId = null, minutos = null, automatico = false }) =>
      escribir(`POST`, `/gestor/modos/activar`, { modoId, minutos, automatico }, `gestor-modo-activar`),
    ajustarChat: (chatId, cambios) =>
      escribir(`PUT`, `/gestor/chats/${chatId}/ajustes`, cambios, `gestor-chat-${chatId}`),
    respuestasAuto: () => api(`/gestor/respuestas-auto`, { sinCache: true, headers }),
    guardarTema: (tema) => escribir(`PUT`, `/gestor/tema`, { tema }, `gestor-tema`),
    /** Enviar ahora o programado (programadoPara: Date o ISO con zona; null = ahora). */
    /** extra: { archivo: {nombre, mime, base64}, citaId } */
    enviar: (chatId, texto, programadoPara = null, extra = {}) =>
      escribir(`POST`, `/gestor/chats/${chatId}/mensajes`, { texto, programadoPara: programadoPara ? new Date(programadoPara).toISOString() : null, ...extra }, `gestor-enviar-${chatId}`),
    reaccionar: (mensajeId, emoji) => escribir(`POST`, `/gestor/mensajes/${mensajeId}/reaccion`, { emoji }, `gestor-reaccion-${mensajeId}`),
    recordatorios: () => api(`/gestor/recordatorios`, { sinCache: true, headers }),
    crearRecordatorio: ({ chatId, mensajeId = null, nota = null, para }) =>
      escribir(`POST`, `/gestor/recordatorios`, { chatId, mensajeId, nota, para: new Date(para).toISOString() }, `gestor-recordatorio-${chatId}`),
    recordatorioHecho: (id) => escribir(`POST`, `/gestor/recordatorios/${id}/hecho`, undefined, `gestor-recordatorio-hecho-${id}`),
    borrarRecordatorio: (id) => escribir(`DELETE`, `/gestor/recordatorios/${id}`, undefined, `gestor-recordatorio-borrar-${id}`),
    resumen: () => api(`/gestor/resumen`, { sinCache: true, headers }),
    generarResumen: ({ horas = 24, conGrupos = false }) => escribir(`POST`, `/gestor/resumen`, { horas, conGrupos }, `gestor-resumen`),
    /** Lo que mandaste a ese chat y todavía importa: pendiente, programado, con error o recién enviado. */
    salientes: (chatId) => api(`/gestor/chats/${chatId}/salientes`, { sinCache: true, headers }),
    programados: () => api(`/gestor/programados`, { sinCache: true, headers }),
    cancelar: (salienteId) => escribir(`DELETE`, `/gestor/salientes/${salienteId}`, undefined, `gestor-cancelar-${salienteId}`),
    nuevoChat: ({ numero, texto, programadoPara = null }) =>
      escribir(`POST`, `/gestor/chats/nuevo`, { numero, texto, programadoPara: programadoPara ? new Date(programadoPara).toISOString() : null }, `gestor-nuevo-chat`),
    plantillas: () => api(`/gestor/plantillas`, { sinCache: true, headers }),
    crearPlantilla: (p) => escribir(`POST`, `/gestor/plantillas`, p, `gestor-plantilla-nueva`),
    guardarPlantilla: (p) => escribir(`PUT`, `/gestor/plantillas/${p.id}`, p, `gestor-plantilla-${p.id}`),
    borrarPlantilla: (id) => escribir(`DELETE`, `/gestor/plantillas/${id}`, undefined, `gestor-plantilla-borrar-${id}`),
    /** Mensajes de un chat; con `antes` (ISO local), los anteriores a esa fecha. */
    mensajes: (chatId, antes = null, limite = 80) =>
      api(`/gestor/chats/${chatId}/mensajes?limite=${limite}${antes ? `&antes=${encodeURIComponent(antes)}` : ``}`, { sinCache: true, headers }),
  };
}

/** Lo que un modo nuevo trae puesto: no esconde nada ni contesta. */
export function modoNuevo() {
  return {
    id: null, nombre: ``, color: `azul`, muestra: `todos`, etiquetas: [], grupos: `todos`,
    presencia: `normal`, respuestaActiva: false, respuesta: ``, respuestaCadaHoras: 4,
    respuestaSoloConocidos: true, respuestaSoloSiAusente: true, respuestaMaxDia: 30, horarios: [], tema: null,
  };
}

export const DIAS = [
  [1, `L`, `lunes`], [2, `M`, `martes`], [3, `X`, `miércoles`], [4, `J`, `jueves`],
  [5, `V`, `viernes`], [6, `S`, `sábado`], [7, `D`, `domingo`],
];

export const COLORES = [`azul`, `verde`, `ambar`, `violeta`, `rojo`, `gris`];

export function horaCorta(fecha) {
  if (!fecha) return ``;
  return new Date(fecha).toLocaleTimeString(`es-PE`, { hour: `2-digit`, minute: `2-digit`, hour12: false });
}

/** «a mano hasta 12:30» / «por horario hasta 18:00» / «a mano». */
export function describirActivo(activo) {
  if (!activo || activo.origen === `ninguno`) return null;
  const como = activo.origen === `manual` ? `a mano` : `por horario`;
  return activo.hasta ? `${como} hasta ${horaCorta(activo.hasta)}` : como;
}

/** Ordena: fijados primero, luego por último mensaje. */
export function ordenarChats(chats) {
  return [...chats].sort((a, b) =>
    Number(b.fijado) - Number(a.fijado) ||
    String(b.ultimoMensajeEn ?? ``).localeCompare(String(a.ultimoMensajeEn ?? ``)));
}

/** Atajos para programar: «En 1 hora», «Hoy 18:00», «Mañana 08:00», «Lunes 08:00». */
export function opcionesProgramar(ahora = new Date()) {
  const a = (d, texto) => ({ cuando: d, texto });
  const en1h = new Date(ahora.getTime() + 3_600_000);
  const hoy18 = new Date(ahora); hoy18.setHours(18, 0, 0, 0);
  const manana8 = new Date(ahora); manana8.setDate(ahora.getDate() + 1); manana8.setHours(8, 0, 0, 0);
  const lunes8 = new Date(ahora); lunes8.setDate(ahora.getDate() + ((8 - ahora.getDay()) % 7 || 7)); lunes8.setHours(8, 0, 0, 0);
  return [
    a(en1h, `En 1 hora`),
    ...(hoy18 - ahora > 30 * 60_000 ? [a(hoy18, `Hoy 18:00`)] : []),
    a(manana8, `Mañana 08:00`),
    a(lunes8, `El lunes 08:00`),
  ];
}

/** «mar 7 oct 08:00». */
export function fechaHora(fecha) {
  const d = new Date(fecha);
  return `${d.toLocaleDateString(`es-PE`, { weekday: `short`, day: `numeric`, month: `short` })} ${horaCorta(d)}`;
}

/** Un archivo del navegador a {nombre, mime, base64} para mandarlo (hasta 16 MB). */
export function leerArchivo(archivo) {
  return new Promise((resolver, rechazar) => {
    if (archivo.size > 16 * 1024 * 1024) { rechazar(new Error(`El archivo pesa más de 16 MB.`)); return; }
    const r = new FileReader();
    r.onload = () => resolver({ nombre: archivo.name || `archivo`, mime: archivo.type || `application/octet-stream`, base64: String(r.result).split(`,`)[1] ?? `` });
    r.onerror = () => rechazar(new Error(`No se pudo leer el archivo.`));
    r.readAsDataURL(archivo);
  });
}

export const tamano = (bytes) => (bytes > 1048576 ? `${(bytes / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`);

export const REACCIONES = [`👍`, `❤️`, `😂`, `😮`, `😢`, `🙏`];
